import { Injectable } from '@angular/core';
import { SendMailService } from '../send-mail/send-mail.service';
import { FormattingService } from '../services/formatting.service';
import { DialogSize, GaMessageService } from '../message/ga-message.service';
import { IMailRequest, SendMailDataService } from '../send-mail/send-mail-data.service';
import { IContact } from '../../../type_definitions/datatypes';
import { IMailInvoiceModel, MailInvoiceComponent } from './mail-invoice.component';
import { EVENT_OPEN_SEND_INVOICE_MAIL_DIALOG, GA1Service } from '../ga1/ga1.service';
import { IGAEvent } from '../services/ga-event.service';
import { InvoiceDataService } from '../invoice-info/invoice-data.service';

export interface IMailInvoiceRequest extends IMailRequest {
  sendToInvoiceContact?:boolean;
  invoiceId?:number;
}

@Injectable()
export class MailInvoiceService extends SendMailService {
  constructor(
    protected formattingService:FormattingService,
    protected messageService: GaMessageService,
    protected sendMailDataService: SendMailDataService,
    private ga1Service:GA1Service,
    private invoiceDataService:InvoiceDataService
   ) {
    super(formattingService, messageService, sendMailDataService);
  }
  public listen():void{
    this.ga1Service.events.subscribe((event:IGAEvent)=> {
      if( event.name === EVENT_OPEN_SEND_INVOICE_MAIL_DIALOG) {
        this.showMailInvoiceDialog(
          'Send Invoice',
           [],
          (sendMailModel:IMailRequest) => {
            return this.invoiceDataService.sendInvoice(sendMailModel, event.data.invoiceId);
          },
          undefined,
          true
        );
      }
    });
  }

  public showMailInvoiceDialog(title:string, to: IContact[], sendFn:(model:IMailInvoiceRequest) => Promise<any>, cancelFn?:() => void, hideSubject?:boolean, checkboxLabel?:string):void {
    this.sendMailDialog = this.messageService.showDialog({
      component: MailInvoiceComponent,
      inputs: {
        title,
        to,
        busy: false,
        disabled: false,
        hideSubject,
        checkboxLabel
      },
      outputs: {
        onSave: (model: IMailInvoiceModel): void => {
          this.setBusy(true);
          this.setDisabled(true);

          const formattedMailModel:IMailInvoiceRequest = {
            to: this.formattingService.formatRecipients(model.to), // comma separated list of contact IDs + email addresses
            cc: this.formattingService.formatRecipients(model.cc), // comma separated list of contact IDs + email addresses
            bcc: this.formattingService.formatRecipients(model.bcc), // comma separated list of contact IDs + email addresses
            body: model.body,
            subject: model.subject,
            sendToInvoiceContact: model.sendToInvoiceContact
          };

          sendFn(formattedMailModel)
            .then(() => {

              this.closeDialog();
            })
            .catch(() => {
              this.setDisabled(false);
            })
            .finally(() => {
              this.setBusy(false);
            });
        },
        onCancel: (): void => {
          if (cancelFn) {
            cancelFn();
          }
          this.closeDialog();
        }
      },
      wrapperComponent: false,
      size: DialogSize.LG
    });
  }

  public getSelectedContacts(rowSelection:any[]):IContact[] {
    return super.getSelectedContacts(rowSelection);
  }
}